module.exports = __webpack_public_path__ + "static/img/study_btn2.1c8ca4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/study_btn2.png
// module id = nlVU
// module chunks = 1